import React, { useEffect, useState } from "react";
import { Button, Container, Col, Form, Nav, Row, Image, Spinner ,Modal } from "react-bootstrap";
import { useNavigate, NavLink } from "react-router-dom";
import trash from "../../../assets/images/icons/trash.svg";
import edit from "../../../assets/images/icons/edit.svg"
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  coachAddExperience,
  coachDeleteExperience,
} from "../../../utils/api";
import { useUserContext } from "../../../utils/hooks/UserContext";
import { toast } from "react-toastify";
import Loader from "../../../Loader/Loader";
import moment from 'moment'

const validFileExtensions = {
  image: ["jpg", "gif", "png", "jpeg", "svg", "webp"],
};

const experienceSchema = Yup.object().shape({
  title: Yup.string()
    .required("Title is required")
    .max(50, "Title must be at most 50 characters"),
  company_name: Yup.string()
    .required("Company is required")
    .max(50, "Company must be at most 50 characters"),
  start_date: Yup.date()
    .required("Start date is required."),
    //.max(Yup.ref('end_date'), "Start date must be before the end date."),
  end_date: Yup.date()
    .nullable()
    .test(
      "validate-dates",
      "End date must be after start date or required when not present.",
      function (value) {
        const { start_date, isPresent } = this.parent; // Access sibling fields
        if (isPresent) return true; // Skip validation if 'isPresent' is true
        if (!value) return false; // 'end_date' is required if 'isPresent' is false
        return new Date(value) > new Date(start_date); // Validate date order
      }
    ),
  isPresent: Yup.boolean(),
});

const EditProfileExperience = (props) => {
    const [experiences, setexperiences] = useState([]);
    const navigate = useNavigate();
    const { getUserFromToken, user } = useUserContext();
    const [editingExperience, setEditingExperience] = useState(false);
    const [currentExperience, setCurrentExperience] = useState(null);
    const [deleteId, setDeleteId] = useState(null);
    const [workexperience, setworkexperience] = useState(null);
    const [isSave, setSaved] = useState(false);
    
    const [isSubmitting, setisSubmitting] = useState(false);
    const [allYears, setAllYears] = useState([]);
    const generateYears = (startYear = 2000) => {
      const currentYear = new Date().getFullYear();
      return Array.from({ length: currentYear - startYear + 1 }, (_, i) => `${currentYear - i}`);
    };
  
    const onRemoveExperience = (id) => {
      setexperiences((prev) =>
        prev.map((exp) => (exp.id === id ? { ...exp, status: "deleted" } : exp))
      );
    };
    useEffect(() => {
      const canonicalUrl = `${window.location.origin}${window.location.pathname}`;
      let link = document.querySelector("link[rel='canonical']");
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
      }
      link.setAttribute("href", canonicalUrl);
      console.log("experiencesuser",user)
      setexperiences(user?.experiences)
      setworkexperience(user?.workexperience);
     
      setAllYears(generateYears(2000)); // Dynamic Year List
    }, [user]);
    
    const handleSubmitExperience = (values, { resetForm }) => {

      const newExperience = {
        id: editingExperience ? currentExperience.id : new Date().getTime(),
        ...values,
        end_date: values.isPresent ? "Present" : values.end_date,
        workexperience: values.workexperience,
        
        status: editingExperience ? "updated" : "new",
      };
  
      if (editingExperience) {
        setexperiences((prev) =>
          prev.map((exp) => (exp.id === currentExperience.id ? newExperience : exp))
        );
      } else {
        setexperiences((prev) => [...prev, newExperience]);
      }
      setSaved(true)
  
      resetForm();
      setEditingExperience(false);
    };
  
    const formikExp = useFormik({
      initialValues: {
        title: "",
        company_name: "",
        start_date: "",
        end_date: "",
        isPresent: false,
        workexperience: "",
      },
      validationSchema: experienceSchema, // Replace with your schema
      onSubmit: handleSubmitExperience, // Your submit handler
    });

    //////////////////////////// End Certificate /////////////////////////////
  
    const handleDelete = (id, delete_type) => {
       if(delete_type === "experience") {
        setDeleteId(id);
        onRemoveExperience(id);
      }
    };
  const [isErrorDate ,setDateError] = useState("")

  useEffect(() => {
    const { years, months, days } = calculateExperience(
      formikExp.values.start_date,
      formikExp.values.isPresent ? null : formikExp.values.end_date
    );
    if(formikExp.values.end_date){
      if(formikExp.values.start_date >= formikExp.values.end_date){
        formikExp.setFieldValue("end_date", "")
        setDateError("End date must be greater than start date")
      }else{
        setDateError("")
      }
    }
    if(formikExp.values.isPresent){
      setDateError("")
    }
    formikExp.setFieldValue(
      "workexperience",
      `${years} years, ${months} months, ${days} days`
    );
  }, [formikExp.values.start_date, formikExp.values.end_date, formikExp.values.isPresent]);
  
  const calculateExperience = (startDate, endDate) => {
    if (!startDate) return { years: 0, months: 0, days: 0 };

    const start = new Date(startDate);
    const end = endDate ? new Date(endDate) : new Date(); // If present, use today's date

    let years = end.getFullYear() - start.getFullYear();
    let months = end.getMonth() - start.getMonth();
    let days = end.getDate() - start.getDate();

    if (days < 0) {
      months -= 1;
      days += new Date(end.getFullYear(), end.getMonth(), 0).getDate();
    }
    if (months < 0) {
      years -= 1;
      months += 12;
    }

    return { years, months, days };
  };
    const onClickSave =async (values) => {
          try {
            // handle program
            console.log("experience ",experiences)
             const newExperience = experiences?.filter((i) => i?.status === "new");
            for (let index = 0; index < newExperience?.length; index++) {
              const element = newExperience[index];
              const formData = new FormData();
              formData.append("title", element?.title);
              formData.append("company_name", element?.company_name);
              formData.append("start_date", element?.start_date);
              formData.append("end_date", element?.end_date);
              formData.append("workexperience", element?.workexperience);
      
              await coachAddExperience(formData);
            }
      
            const deletedExperience = experiences?.filter(
              (i) => i?.status === "deleted"
            );
      
            if (deletedExperience?.length > 0) {
              const formData = new FormData();
              formData.append(
                "experience_ids",
                `[${deletedExperience?.map((i) => i?.id)}]`
              );
      
              await coachDeleteExperience(formData);
            }
              setSaved(false)

              toast.success("Experience updated successfully.")
            } catch (error) {
            toast.error(error?.response?.data?.message || error?.message);
          }
      
          getUserFromToken();
      
    }
  return (
    <>
    <Modal size="lg" {...props} aria-labelledby="contained-modal-title-vcenter" centered>
      <div className="profile_edit_forms my_light_modal">
          <Container>
            <Row className='g-3'>
              <Col lg="12">
                <Form className="px-3 py-2" onSubmit={formikExp.handleSubmit}>
                  <Col sm="12" className="mb-4">
                    <Form.Label className="title">Experience</Form.Label>
    
                    {experiences
                      ?.filter((i) => i?.status !== "deleted")
                      ?.map((experience) => (
                        <Row className="align-items-center" key={experience.id}>
                          <Col className="col-12 mx-auto">
                            <div className="pr_dtls_prvw">
                              <div>
                                <p className="fs-16 fw-500 text_brand_color4 m-0">
                                  {experience.title}
                                </p>
                                <small className="d-block fs-12 fw-400 text_brand_color4">
                                  {experience.company_name}
                                </small>
                                <small className="d-block fs-12 fw-400 text_brand_color4">
                                  {experience.start_date}
                                </small>
                                <small className="d-block fs-12 fw-400 text_brand_color4">
                                  {experience.end_date}
                                </small>
                              </div>
                              <div className="d-flex align-items-center">
                                <Button
                                  className="p-0 m-2"
                                  variant=""
                                  onClick={() => handleDelete(experience?.id, "experience")}
                                >
                                  <Image src={trash} />
                                </Button>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      ))}
    
                    {/* Experience Form Fields */}
                    <Row className="align-items-center">
                      <Col sm="4" className="mb-3">
                        <Form.Control
                          type="text"
                          placeholder="Title"
                          name="title"
                          value={formikExp.values.title}
                          onChange={formikExp.handleChange}
                          isInvalid={
                            formikExp?.touched?.title && !!formikExp?.errors?.title
                          }
                        />
                        <Form.Control.Feedback type="invalid">
                          {formikExp?.errors?.title}
                        </Form.Control.Feedback>
                      </Col>
                      <Col sm="4" className="mb-3">
                        <Form.Control
                          type="text"
                          placeholder="Company"
                          name="company_name"
                          value={formikExp.values.company_name}
                          onChange={formikExp.handleChange}
                          isInvalid={
                            formikExp?.touched?.company_name &&
                            !!formikExp?.errors?.company_name
                          }
                        />
                        <Form.Control.Feedback type="invalid">
                          {formikExp?.errors?.company_name}
                        </Form.Control.Feedback>
                      </Col>
                      <Col sm="4" className="mb-3">
                        <Form.Control
                          type="date"
                          placeholder="Start Date"
                          name="start_date"
                          className="calender"
                          value={formikExp.values.start_date}
                          onChange={formikExp.handleChange}
                          max={new Date().toISOString().split("T")[0]} // Disable future dates
                          isInvalid={formikExp?.touched?.start_date && !!formikExp?.errors?.start_date}
                        />
                        <Form.Control.Feedback type="invalid">
                          {formikExp?.errors?.start_date && formikExp?.touched?.start_date && (
                            <div>{formikExp?.errors?.start_date}</div>
                          )}
                        </Form.Control.Feedback>
                      </Col>
    
                      <Col as={Col} sm="3" className="mb-3">
                        <Form.Control
                          type="date"
                          placeholder="End Date"
                          name="end_date"
                          className="calender"
                          value={formikExp.values.isPresent ? "" : formikExp.values.end_date}
                          onChange={formikExp.handleChange}
                          disabled={formikExp.values.isPresent || !formikExp.values.start_date}
                          max={new Date().toISOString().split("T")[0]} // ✅ Disable future dates
                          // disabled={!formikExp.values.start_date}
                          isInvalid={formikExp?.touched?.end_date && !!formikExp?.errors?.end_date}
                        />
                        {isErrorDate && (
                          <div className="text-danger">{isErrorDate}</div>
                        )}
                        <Form.Control.Feedback type="invalid">
                          {formikExp?.errors?.end_date && formikExp?.touched?.end_date && (
                            <div>{formikExp?.errors?.end_date}</div>
                          )}
                        </Form.Control.Feedback>
                      </Col>
    
                      <Col as={Col} sm="2" className="mb-3">
                        <Form.Check
                          type="checkbox"
                          label="Present"
                          name="isPresent"
                          disabled={experiences.some((exp) => exp.isPresent)}
                          checked={formikExp.values.isPresent}
                          onChange={(e) =>
                            formikExp.setFieldValue("isPresent", e.target.checked)
                          }
                        />
                      </Col>
    
                      <Col as={Col} sm="4" className="mb-3">
                          {/*type="number"disabled="true"*/}
                        <Form.Control
                          type="text"
                          disabled="true"
                          placeholder="Experience (In Years)"
                          name="workexperience"
                          value={formikExp.values.workexperience}
                          onChange={formikExp.handleChange}
                          isInvalid={
                            formikExp?.touched?.workexperience &&
                            !!formikExp?.errors?.workexperience
                          }
                        />
                        <Form.Control.Feedback type="invalid">
                          {formikExp?.errors?.workexperience}
                        </Form.Control.Feedback>
                      </Col>
                      <Col sm="3" className="mb-3">
                        <Button type="submit" variant="success" className="px-4"
                      disabled={!formikExp.values.title || !formikExp.values.company_name || !formikExp.values.start_date}
                      >
                          Add
                        </Button>
                      </Col>
                    </Row>
                  </Col>
                </Form>
              </Col>
            </Row>
            <Row className='justify-content-end mt-4'>
              <Col sm="auto">
                  <Button variant='success' className='px-5' disabled={!isSave} onClick={isSave ? onClickSave : undefined}>Save</Button>
              </Col>
            </Row>
          </Container>

      </div>
    </Modal>
    </>
  );
}

export default EditProfileExperience;